module.exports = __webpack_public_path__ + "static/media/blue.3f6d2b77.png";